module.exports = __webpack_public_path__ + "img/seafarers.051e9272.png";